import { useEffect } from 'react';
import { GrispiEvents } from '../../EventAndActionNames';
import useCurrentTicket from '../../hooks/ticketDetailPage/useCurrentTicket';
import getStore from '../../utils/store/getStore';

const useActiveTicketChangeListener = (): void => {
    const { data } = useCurrentTicket();

    useEffect(() => {
        if (data) {
            // console.warn('SETTING xxx', ticketKey, data);
            getStore().ActiveTicketStore.setActiveTicket(data);
            const event = new CustomEvent(GrispiEvents.MESSAGE_TO_PLUGIN, {
                detail: {
                    pluginId: '*',
                    data: { type: GrispiEvents.ACTIVE_TICKET_CHANGED, parameters: [data] }
                }
            });
            window.dispatchEvent(event);
        }
    }, [data]);
};

export default useActiveTicketChangeListener;
